// Shared helpers for forms that pick a deadline (datetime-local) — the input has no timezone,
// so it is read as the browser's local time and sent to the API as an absolute ISO instant.
export const toIso = (localValue) => new Date(localValue).toISOString();

export const toLocalInput = (iso) => {
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const nowLocalInput = () => toLocalInput(new Date().toISOString());

export const fmtDateTime = (d) =>
  d ? new Date(d).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) : '—';

export function StaffRadioList({ staff, value, onChange, emptyText }) {
  if (staff.length === 0) {
    return <p className="rounded-md bg-gray-100 px-3 py-2 text-sm text-gray-600">{emptyText}</p>;
  }
  return (
    <ul className="max-h-56 divide-y divide-gray-100 overflow-y-auto rounded-md border border-gray-200">
      {staff.map((s) => (
        <li key={s.id}>
          <label className="flex cursor-pointer items-center gap-3 px-3 py-2 hover:bg-gray-50">
            <input
              type="radio"
              name="assignee"
              checked={value === s.id}
              onChange={() => onChange(s.id)}
              className="h-4 w-4 border-gray-300 text-primary focus:ring-primary"
            />
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-gray-900">{s.name}</span>
              <span className="block truncate text-xs text-gray-400">{s.email}</span>
            </span>
          </label>
        </li>
      ))}
    </ul>
  );
}
